import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { scrollbarStyles } from '@web/components/ScrollableContainer/ScrollableContainer';

type ListProps = { shouldApplyFallback?: boolean };
export const List = styled.ol<ListProps>`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
  bottom: 100%;
  box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.12);
  left: 0;
  list-style: none;
  margin: 0;
  max-height: 170px;
  padding: 10px 0 10px 10px;
  position: absolute;
  right: 0;

  ${scrollbarStyles}

  padding-right: ${({ shouldApplyFallback }) => (shouldApplyFallback ? '11px' : '0px')};
`;

export const Wrapper = styled.div`
  position: relative;

  ${List} {
    display: none;
  }

  &:focus-within ${List} {
    display: block;
  }
`;

export const ToggleButton = styled.label`
  align-items: center;
  border-radius: 4px;
  color: ${({ theme }) => `${theme.colors.gray}cc`}; // 80% alpha
  cursor: pointer;
  display: flex;
  flex-flow: row nowrap;
  justify-content: start;
  gap: 10px;
  font-size: 12px;
  font-weight: 600;
  margin: 0;
  padding: 8px 5px;
  transition: all 0.25s ease;

  svg {
    color: ${({ theme }) => theme.colors.iconGray};
    opacity: 0.65;
    transition: all 0.25s ease;
    transform: translateZ(0);
  }

  &:hover,
  &:hover svg {
    background-color: ${({ theme }) => `${theme.colors.primary}0c`}; // 5% alpha
    color: ${({ theme }) => theme.colors.primary};
    opacity: 1;
  }

  &:focus,
  &:focus svg {
    color: ${({ theme }) => theme.colors.primary};
    opacity: 1;
  }
`;

type ItemProps = {
  isActive: boolean;
};

export const Item = styled.li<ItemProps>`
  background-color: transparent;
  border-radius: 4px;
  color: ${({ theme }) => theme.colors.iconGray};
  line-height: 20px;
  opacity: ${({ isActive }) => (isActive ? 1 : 0.5)};
  transition: background-color 0.25s ease;

  &:hover {
    background-color: ${({ theme }) => `${theme.colors.primary}0c`}; // 5% alpha
  }
`;

export const ItemLink = styled(Link)`
  align-items: center;
  color: inherit;
  display: block;
  display: flex;
  font-size: 12px;
  font-weight: 600;
  justify-content: space-between;
  line-height: 20px;
  overflow: hidden;
  padding: 5px 10px;
  text-overflow: ellipsis;
  transition: color 0.25s ease;
  white-space: nowrap;

  &:hover,
  &:focus {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: none;
  }
`;
